import React, { useEffect, useState } from "react";
import { Typography, Box } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid/";
import { WatchActions } from "../../../../state";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { getDetailButton } from "../../../../lib";
import { AddWatchAttribute } from ".";
import { QuickSearchToolbar, escapeRegExp } from "../../../../lib/utils";

const useStyles = makeStyles(() => ({
  dataGrid: {
    '& .MuiDataGrid-row': {
      '&:hover': { backgroundColor: 'rgba(63, 81, 181, 0.04)' },
    },
    '& .MuiDataGrid-cell': {
      borderBottom: '1px solid rgba(224, 224, 224, 0.4)',
      fontSize: '0.875rem',
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#fafafa',
      borderBottom: '2px solid rgba(224, 224, 224, 1)',
      fontSize: '0.875rem',
      fontWeight: 600,
    },
    '& .MuiDataGrid-columnHeader': {
      '&:focus, &:focus-within': { outline: 'none' },
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
  },
}));

const columns = [
  { field: "id", headerName: "ID", flex: 0.3, headerAlign: "center", align: "center" },
  { field: "name", headerName: "Name", flex: 1 },
  {
    field: "handsFinishCount",
    headerName: "Hands Finish Count",
    type: "number",
    flex: 0.5,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "hourMarkerFinishCount",
    headerName: "Hour Marker Finish Count",
    type: "number",
    flex: 0.5,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "button",
    headerName: "Details",
    flex: 0.5,
    filterable: false,
    renderCell: (params) =>
      getDetailButton("watch-details", params.value, "hands_finish", false),
  },
];

export function WatchAttributesFinishTabs() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const siteId = useSelector((state) => state.scopes.site_id);
  const [rawRows, setRawRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    (async () => {
      const data = await dispatch(WatchActions.getAttribute("hands_finish", null, siteId));
      if (data) setRawRows(data);
    })();
  }, [siteId, refresh, dispatch]);

  useEffect(() => {
    const mapped = rawRows.map((row) => ({
      id: row.hands_finish_id,
      name: row.hands_finish,
      handsFinishCount: row.hands_finish_count,
      hourMarkerFinishCount: row.hour_marker_finish_count,
      button: row,
    }));
    setRows(mapped);
  }, [rawRows]);

  const requestSearch = (value) => {
    setSearchText(value);
    const regex = new RegExp(escapeRegExp(value), "i");
    const mapped = rawRows.map((row) => ({
      id: row.hands_finish_id,
      name: row.hands_finish,
      handsFinishCount: row.hands_finish_count,
      hourMarkerFinishCount: row.hour_marker_finish_count,
      button: row,
    }));
    setRows(mapped.filter((row) =>
      Object.keys(row).some((field) => regex.test(row[field]?.toString()))
    ));
  };

  return (
    <Box style={{ width: "100%" }}>
      <Box display="flex" justifyContent="center" mb={2}>
        <Typography variant="h6">Hands &amp; Hour Marker Finish</Typography>
      </Box>
      <div style={{ maxWidth: 800, margin: "0 auto" }}>
        <AddWatchAttribute
          attribute="Hands / Hour Marker Finish"
          rawAttribute="hands_finish"
          path="watch-attributes"
          onSuccess={() => setRefresh((n) => n + 1)}
        />
      </div>
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <DataGrid
          className={classes.dataGrid}
          rows={rows}
          columns={columns}
          disableColumnMenu={true}
          isRowSelectable={false}
          pageSize={100}
          checkboxSelection={false}
          autoHeight={true}
          rowHeight={38}
          sortModel={[{ field: "name", sort: "asc" }]}
          components={{ Toolbar: QuickSearchToolbar }}
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (e) => requestSearch(e.target.value),
              clearSearch: () => requestSearch(""),
            },
          }}
        />
      </div>
    </Box>
  );
}